// removed by extract-text-webpack-plugin
module.exports = {"RoundButton":"RoundButton__RoundButton__30Yu8","RoundButtonDisabled":"RoundButton__RoundButtonDisabled__HFnRh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/RoundButton/RoundButton.css
// module id = 168
// module chunks = 0